import { createContext, useContext } from 'react'

export const SlipsOpenEditSiteContext = createContext<null | (() => void)>(
  null
)

export function useSlipsOpenEditSite() {
  return useContext(SlipsOpenEditSiteContext)
}
